import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/contracts/rent-object-bookings/${formData.rentObjectBookingId}`, formData);
  },
  async back(formData) {
    return axios.post(`/contracts/${formData.contractId}/back`, formData);
  },
  async cancel(formData) {
    return axios.post(`/contracts/${formData.contractId}/cancel`, formData);
  },
  async findAll(formData) {
    return axios.get(`/contracts/rent-object-bookings/${formData.rentObjectBookingId}`);
  },
  async getAttachement(formData) {
    return axios.get(`/contracts/${formData.id}/pdf`, { responseType: 'arraybuffer' });
  },
  async getDigitalSignatureContractsNotPrinted() {
    return axios.get(`/contracts/digital/not-printed`);
  },
  async setIsPrintedOnPaper(formData) {
    return axios.patch(`/contracts/printed-on-paper/${formData.id}`, formData);
  },
  async delete({ id }) {
    return axios.delete(`/contracts/${id}`);
  },
  async search(payload) {
    let url = `/contracts/search?search=${payload.searchString}`
    return axios.get(url);
  },
};